import CodeBlock from '../components/CodeBlock';
import { errorCodes } from '../data/errorCodes';

export default function Errors() {
  return (
    <section id="errors" className="mb-16">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Errors</h3>
      <p className="text-gray-700 mb-6">
        Snaptura uses conventional HTTP response codes to indicate the success or failure
        of an API request.
      </p>

      <div className="space-y-4 mb-8">
        {errorCodes.map((error) => (
          <div key={error.code} className="border-l-4 border-red-400 pl-4">
            <h4 className="text-lg font-semibold text-gray-900">
              {error.code} - {error.name}
            </h4>
            <p className="text-gray-700">{error.description}</p>
          </div>
        ))}
      </div>

      <h4 className="text-lg font-semibold text-gray-900 mb-3">Example Error Responses</h4>

      <div className="space-y-6">
        <div>
          <p className="text-sm text-gray-600 mb-2">400 Bad Request</p>
          <CodeBlock section="error400" />
        </div>

        <div>
          <p className="text-sm text-gray-600 mb-2">401 Unauthorized</p>
          <CodeBlock section="error401" />
        </div>

        <div>
          <p className="text-sm text-gray-600 mb-2">429 Too Many Requests</p>
          <CodeBlock section="error429" />
        </div>
      </div>

      <div className="mt-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-3">Success Response</h4>
        <CodeBlock section="responseSuccess" />
      </div>
    </section>
  );
}